import InnerHeader from 'component/shared/innerheader/InnerHeader'
import React from 'react'
import { useIntl } from "react-intl";
import CategoryGuide from 'component/externalTrade/category-guide';
import LabelLang from 'component/LabelLang/label-lang';
import Seasons from 'component/externalTrade/seasons';
import CountrySpecificCategory from 'component/externalTrade/country-specific-category';
import DegreeofUse from 'component/externalTrade/degree-of-use';
import ImporterExporter from 'component/externalTrade/importer-exporter';
import Countries from 'component/externalTrade/countries';
import Items from 'component/externalTrade/Items';
import Totals from 'component/externalTrade/totals';
import Tarrif from 'component/externalTrade/tariff-4-limits';
import TradeBalance from 'component/externalTrade/trade-balance';
import Tooltip from '@mui/material/Tooltip';
import { LabelLangString } from "component/LabelLang/label-lang";
import { useSelector } from 'react-redux';
import useSWR from 'swr';
import { EXTERNAL_TRADE_BASE_URL } from 'configs/AppConfig';
import { END_POINTS } from 'constants/APIConstant';
import ContentLoading from 'component/LoadingComponent/ContentLoading';

function ExternalTrade() {

    const intl = useIntl();

    const currentLocale = useSelector(({ theme }) => theme.locale);

    React.useEffect(() => {
      const timeOut = setTimeout(() => {
        window.scrollTo(0, 0);
      }, 0);
      return () => {
        clearTimeout(timeOut);
      };
    }, []);

    const yearMonthDate = useSWR({
      url: `${EXTERNAL_TRADE_BASE_URL}/${END_POINTS.YEAR_MONTH_LOOKUP}`,
    });

    const [categoriesTabToggle, setcategoriesTabToggle] = React.useState(1);
  
    const tabCategory = (index) => {
      setcategoriesTabToggle(index);
    };
  
    const categoriesData = [
      {
          id: 1,
          category: "طبقا للدولـة",
          tooltip: '',
          translation: [
              {
              category: "By country",
              tooltip: '',
              locale: "en",
              },
          ],
      },
      {
          id: 2,
          category: "طبقا للصنـف (HS code 10 digit)",
          tooltip: '',
          translation: [
              {
              category: "By item (HS code 10 digit)",
              tooltip: '',
              locale: "en",
              },
          ],
      },
      {
          id: 3,
          category: "طبقا للدولة وصنف محدد",
          tooltip: '',
          translation: [
              {
              category: "By Country and specific item",
              tooltip: '',
              locale: "en",
              },
          ],
      },
      {
          id: 4,
          category: "طبقا للفصـل (HS code 2 digit)",
          tooltip: '',
          translation: [
              {
              category: "By chapter (HS code 2 digit)",
              tooltip: '',
              locale: "en",
              },
          ],
      },
      {
          id: 5,
          category: "طبقا للبنـد الرئيسـي (HS code 4 digit)",
          tooltip: '',
          translation: [
              {
              category: "By heading (HS code 4 digit)",
              tooltip: '',
              locale: "en",
              },
          ],
      },
      {
          id: 6,
          category: "طبقا لدرجة الإستخدام والتصنيع",
          tooltip: '',
          translation: [
              {
              category: "By degree of use or manufacture",
              tooltip: '',
              locale: "en",
              },
          ],
      },
      {
          id: 7,
          category: "إجماليـات",
          tooltip: 'أكبر 50 صنف - أكبر 50 دولة - الفصول - البنود الرئيسية - سلع زراعية - سلع غذائية',
          translation: [
              {
              category: "By totals",
              tooltip: 'top 50 items - top 50 countries - chapters - Headings - agricultural commodities - food commodities',
              locale: "en",
              },
          ],
      },
      {
          id: 8,
          category: "الميزان التجـاري",
          tooltip: 'إجمالي - طبقا للمناطق الجغرافية - طبقا للتكتلات الإقتصادية',
          translation: [
              {
              category: "By trade balance",
              tooltip: 'Total - by geographical regions - by economic blocs',
              locale: "en",
              },
          ],
      },
      {
          id: 9,
          category: "شركات التصدير والإستيراد",
          tooltip: '',
          translation: [
              {
              category: "Export and import companies",
              tooltip: '',
              locale: "en",
              },
          ],
      },
      {
          id: 10,
          category: "دليل الأصنـاف",
          tooltip: '',
          translation: [
              {
              category: "Items guide",
              tooltip: '',
              locale: "en",
              },
          ],
      },
    ];


    const renderCategory = () => {
      const rendering = categoriesData.map(({ id, category, tooltip, translation }, index) => {
        return (
          <Tooltip
            title={LabelLangString({
                id: "tooltip",
                currentLocale: currentLocale,
                defaultValue: tooltip,
                translations: translation,
            })}
            key={index}
          >
            <li
              className={`${categoriesTabToggle === id ? "active" : "item"}`}
              onClick={() => {
                  tabCategory(id);
                  renderOutletCategory()
              }}
            >
              <LabelLang
                id="category"
                defaultValue={category}
                translations={translation}
              />
            </li>
          </Tooltip>
        );
      });
      return rendering;
    };


    const renderOutletCategory = () => {
      switch (categoriesTabToggle) {

        case 1:
          return <Countries yearMonthDate={yearMonthDate?.data?.data} />;
          break;

        case 2:
          return <Items yearMonthDate={yearMonthDate?.data?.data} />;
          break;

        case 3:
          return <CountrySpecificCategory yearMonthDate={yearMonthDate?.data?.data} />;
          break;

        case 4:
          return <Seasons yearMonthDate={yearMonthDate?.data?.data} />;
          break;
          
        case 5:
          return <Tarrif yearMonthDate={yearMonthDate?.data?.data} />;
          break;
          
        case 6:
          return <DegreeofUse yearMonthDate={yearMonthDate?.data?.data} />;
          break;
      
        case 7:
          return <Totals yearMonthDate={yearMonthDate?.data?.data} />;
          break;

        case 8:
          return <TradeBalance yearMonthDate={yearMonthDate?.data?.data} />;
          break;
          
        case 9:
          return <ImporterExporter />;
          break;
          
        case 10:
          return <CategoryGuide />;
          break;
      
        default:
          return <Countries yearMonthDate={yearMonthDate?.data?.data} />;
          break;
      }
    }

  return (
    <ContentLoading isLoading={yearMonthDate.isLoading}>
      <div className='external-trade'>
        <InnerHeader
          breadcrumb={[
              { title: intl.formatMessage({ id: "data" }), clickClass: false },
              { title: intl.formatMessage({ id: "external-trade" }), clickClass: true }
          ]}
          title={intl.formatMessage({ id: "browse-external-trade-gate" })}
          route={'../data'}
          profileFile={true}
        />
        <div className="container">
          <div className="row my-4">
              <div className="col-12 col-lg-4">
                <div className="searchBy-ob">
                  <h5>{intl.formatMessage({ id: "browse-external-trade-by" })}</h5>
                  <ul>
                    {renderCategory()}
                  </ul>
                </div>
              </div>
              <div className="col-12 col-lg-8">
                <div className="">
                  {renderOutletCategory()}
                </div>
              </div>
          </div>
        </div>
      </div>
    </ContentLoading>
  )
}

export default ExternalTrade